function emitWarning() {
    if (!emitWarning.warned) {
      emitWarning.warned = true;
      console.log(
        'Deprecation (warning): Using file extension in specifier is deprecated, use "highlight.js/lib/languages/python-repl" instead of "highlight.js/lib/languages/python-repl.js"'
      );
    }
  }
  emitWarning();
    module.exports = require('./python-repl.js');